import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TitleSection } from '../../core/models';
import { Location } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { TitleSectionComponent } from '../components/title-section/title-section.component';
@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  standalone: true,
  imports: [TitleSectionComponent],
})
export class Page404Component implements OnDestroy {
  constructor(
    public readonly location: Location,
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly meta: Meta
  ) {
    this.meta.updateTag({ name: 'robots', content: 'noindex, max-image-preview:large' });
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.add('hiden-footer-subscribe');
    }
  }
  ngOnDestroy(): void {
    this.meta.updateTag({ name: 'robots', content: 'max-image-preview:large' });
  }
  data: TitleSection = {
    name: '404 error',
    title: 'Page not found',
    descriptions:
      'We’re sorry, but the page you’re looking for could not be found. It may have been moved, deleted, or never existed in the first place.',
    isBigTitle: true,
  };
}
